import React from 'react';
import { Form, Formik } from 'formik';

import { createFormValidationFn, createInitialValues } from 'client/helpers/formikHelpers';

import SrErrorMessage from 'client/components/SrErrorMessage/SrErrorMessage';
import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import SrCard, { SR_CARD_BULLET_COLOR_BLUE } from 'client/components/SrCard/SrCard';
import ButtonDeprecated, {
  BUTTON_THEME_GREY_ADOBE,
  BUTTON_THEME_GREEN_ADOBE,
} from 'client/components/ButtonDeprecated';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import useSrSunSetupAdminUpdateItemController from 'client/components/SrSunSetupAdminUpdateItem/useSrSunSetupAdminUpdateItemController';
import SrButton from 'client/components/SrButton/SrButton';

const SrSunSetupAdminUpdateItem = () => {
  const { state, actions, form } = useSrSunSetupAdminUpdateItemController();

  const formFields = state.itemBeingUpdated
    ? actions.getUpdateItemFormFields()
    : actions.getFindItemFormFields();

  const initialValues = state.itemBeingUpdated
    ? createInitialValues({
        formFields: formFields,
        defaultValues: {
          ...state.itemBeingUpdated,
        },
      })
    : createInitialValues({
        formFields: formFields,
      });

  const onSubmit = state.itemBeingUpdated ? actions.updateInventoryItem : actions.findInventoryItem;

  return (
    <SrCard header="Update Item Status" color={SR_CARD_BULLET_COLOR_BLUE} maxWidth="none">
      {form.itemType && (
        <SrBox margin="16px 0px">
          <SrBox>
            <SrText font="greycliff" fontSize="20px" weight="800">
              {form.itemType} - #{form.itemSerialNumber}
            </SrText>
          </SrBox>
          <SrBox>
            <SrText font="greycliff" fontSize="16px" weight="600">
              Item is owned by {form.itemOwnerName}
            </SrText>
          </SrBox>
        </SrBox>
      )}
      <Formik
        initialValues={initialValues}
        validate={createFormValidationFn(formFields)}
        onSubmit={onSubmit}
        enableReinitialize
        render={(formikBag) => (
          <Form>
            {formFields.map((formField) => (
              <SrFormikField
                key={formField.id}
                formField={formField}
                formikBag={formikBag}
                className={SR_FIELD_THEME_ADOBE}
              />
            ))}
            <SrBox marginTop={20}>
              <ButtonDeprecated
                type="submit"
                theme={BUTTON_THEME_GREEN_ADOBE}
                disabled={!formikBag.isValid}
                onClick={formikBag.handleSubmit}
              >
                {state.buttonLabel}
              </ButtonDeprecated>
              {state.itemBeingUpdated && (
                <SrButton
                  type="button"
                  theme={BUTTON_THEME_GREY_ADOBE}
                  onClick={actions.cancelSearch}
                  margin="10px 0"
                >
                  Cancel
                </SrButton>
              )}
            </SrBox>
            {state.itemUpdateError && <SrErrorMessage>{state.itemUpdateError}</SrErrorMessage>}
          </Form>
        )}
      />
    </SrCard>
  );
};

export default SrSunSetupAdminUpdateItem;
